module.exports = __webpack_public_path__ + "img/uil_print.12a1ff1c.svg";